/**
 * @file コンポーネント：利用規約英語 DOM管理
 */

// ライブラリ読み込み
import React from "react";

// スタイル読み込み
import { StyledTerms } from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ReactDOM
    return (
        <StyledTerms data-on-color={props.onColor}>
            <h3>
                Terms of Use for opeXpark
            </h3>
            <section>
                <h4>
                    Purpose
                </h4>
                <ol>
                    <li>
                        These terms of use ("Terms of Use") are applicable to all users of the "opeXpark" service(s) ("Services") ("Users") provided and operated by OPExPARK Inc. ("Company"). Users shall use the Services upon agreeing to these Terms of Use.
                    </li>
                    <li>
                        These Terms of Use stipulate terms and conditions for using the Services. All Users registered in the Services must use the Services in accordance with the conditions as stated in these Terms of Use as applicable, including age and usage.
                    </li>
                    <li>
                        By agreeing to these Terms of Use, the User will have entered into the Agreement (as defined in Article 2 of these Terms of Use) between the Company.
                    </li>
                </ol>
            </section>
            <section>
                <h4>
                    Definitions
                </h4>
                <p>
                    For the purposes of these Terms of Use, the following terms have the meanings in the following items:
                </p>
                <ol data-hierarchy="second">
                    <li>
                        "Agreement" means Services agreements to be concluded between the Company and Users under the terms and conditions as stipulated in these Terms of Use;
                    </li>
                    <li>
                        "Services" means the "opeXpark" services (If the name or content of the Service is changed for any reason, it shall include the Service after such change.) provided and operated by Company
                    </li>
                    <li>
                        "Paid Services" means the services provided for a fee within the Services.
                    </li>
                    <li>
                        "User(s)" means a person or all persons registered with the Services;
                    </li>
                    <li>
                        "User Information" means ID and password of Users registered with the Services; and
                    </li>
                    <li>
                        "Communication Equipment" means smartphones, tablets, and computer equipment.
                    </li>
                </ol>
            </section>
            <section>
                <h4>
                    User Registration
                </h4>
                <ol>
                    <li>
                        A person who intends to become a User must agree to the contents of these Terms of Use and complete the registration process based on the procedures required by the Company, however only users who hold a medical license as defined by the government are eligible to register.
                    </li>
                    <li>
                        If there is any change to the information registered by the Users in accordance with the immediately preceding paragraph, Users must immediately change the registered information.
                    </li>
                    <li>
                        The Company may refuse registration made by the Users at its sole discretion. The Company is not obligated to disclose any reasons.
                    </li>
                    <li>
                        Users are prohibited from permitting any third party to use their accounts on the Services, transfer, assign or pledge such accounts as collateral to any third party.
                    </li>
                </ol>
            </section>
            <section>
                <h4>
                    Contents of the Services
                </h4>
                <p>
                    The Services that the Company provides to the Users consist of surgical procedures and related information.
                </p>
            </section>
            <section>
                <h4>
                    Usage Fees
                </h4>
                <ol>
                    <li>
                        Users pay to the Company a usage fee separately determined for each Content by the Company as compensation for the use of the Paid Services, only by a method(credit card, etc.) designated by the Company.
                    </li>
                    <li>
                        Users who use paid services may not change the contents or cancel their orders after the order has been placed due to the nature of the contents. The Company does not refund the usage fee received under any circumstances.
                    </li>
                    <li>
                        Users bare the telecommunication costs and prepare telecommunication equipment required to use the Service. However, The Company does not guarantee that the Website or the Service will operate properly on the telecommunications equipment, etc. used by the User
                    </li>
                </ol>
            </section>
            <section>
                <h4>
                    Management of User Information and Communication Equipment
                </h4>
                <ol>
                    <li>
                        Users must prepare all the necessary equipment, including Communication Equipment and transportation necessary for enjoying the Services at their own expense. Users must bear all the communication costs necessary for using the Services.
                    </li>
                    <li>
                        Users must manage their User Information and Communication Equipment. Users are responsible for any damage, including damage arising from mis-management of User Information or Communication Equipment, errors in using the Services, and use of Services by any third party, and the Company will not be responsible for any such damage unless it is caused by the Company's negligence or willful misconduct.
                    </li>
                    <li>
                        Users must immediately inform the Company and follow the Company's instructions if there is any indication of third party's use of Users' Information or Communication Equipment.
                    </li>
                </ol>
            </section>
            <section>
                <h4>
                    Conditions for Providing the Services
                </h4>
                <p>
                    The Company may suspend or change the Services without notifying Users of such suspension or change for any reason, including due to maintenance.
                </p>
            </section>
            <section>
                <h4>
                    Intellectual Property Rights
                </h4>
                <ol>
                    <li>
                        If a User or Users post or upload their work product on the platform used in the Services, such User or Users must agree to grant, free of charge and to an unlimited extent, the Company a license to use all copyrights (including the rights stipulated in Articles 27 and 28 of the Copyright Act) concerning any part or all of such work for any purpose, regardless of the copyrightability of such work.
                    </li>
                    <li>
                        Users may not use, reproduce, publicly transmit, or modify any information or contents provided in the Services (collectively, "Company Contents") beyond the scope of "private use" as stipulated in the Copyright Act of Japan.
                    </li>
                    <li>
                        All intellectual property rights, including copyrights, patents, utility model registrations, trademark rights, design rights, and rights to make registrations based on such former rights (collectively "Intellectual Property Rights") relating to the Services, belong to the Company or to third parties who are the respective right holders. Users must not engage in any secondary usage of the Company Contents, including reproducing, distributing, reprinting, transmitting, publicly transmitting, modifying, or adapting the Company Contents.
                    </li>
                    <li>
                        If Users breach any provision of this Article 8 and cause any damage to the Company, such Users must resolve such damage at their sole cost and expense and take the appropriate measures to hold the Company harmless from any disadvantage, burden or damage.
                    </li>
                    <li>
                        Users must not exercise their authors' personal rights (including rights to make a work public, rights to indicate a name, and rights to preserve integrity) concerning any part or all of their posted contents, which might potentially be a copyright work, against the Company, any third party which duly obtains relevant rights from the Company, or any person which succeeds such rights from such third party.
                    </li>
                </ol>
            </section>
            <section>
                <h4>
                    Prohibited Acts
                </h4>
                <ol>
                    <li>
                        Regarding Users' use of the Services, the Company prohibits any of the acts in the following items:
                        <ol data-hierarchy="second">
                            <li>
                                acts that breach these Terms of Use;
                            </li>
                            <li>
                                acts that violate or likely violate proprietary and personal rights, including Intellectual Property Rights, patent, utility model, design, trademark, copyright and publicity rights of the Company or any third party including a licensor granting a license to the Company;
                            </li>
                            <li>
                                acts that cause or likely cause any disadvantage or damage to the Company or any third party;
                            </li>
                            <li>
                                acts that unlawfully damage or likely damage the honor, right, or credit of other persons;
                            </li>
                            <li>
                                acts that breach any rules including laws, regulations, and municipal ordinances;
                            </li>
                            <li>
                                acts that damage or likely damage any public policy, and acts that provide other Users or any third party with information which likely damage any public policy;
                            </li>
                            <li>
                                criminal acts, any acts which lead to criminal acts, or acts to instigate or likely instigate such acts;
                            </li>
                            <li>
                                acts that provide false information or information that is likely false;
                            </li>
                            <li>
                                acts that prevent or likely prevent the Services from its normal operation, including unlawful access to the Company's systems, or that falsify program codes, falsify location information, cheat using any Communication Equipment and applications, and spread any computer virus;
                            </li>
                            <li>
                                acts that use Macro program or any function or tool enabling automatic manipulation;
                            </li>
                            <li>
                                acts that damage or likely damage the credibility of the Services;
                            </li>
                            <li>
                                acts that cause any negative influence upon young people or their sound growth;
                            </li>
                            <li>
                                acts that pretend to be a third party and use the Services, such as using other Users' accounts;
                            </li>
                            <li>
                                fraud and illegal purchase of a bank account or a portable phone;
                            </li>
                            <li>
                                criminal acts or acts of terrorism, or any such suspected acts;
                            </li>
                            <li>
                                acts that record the display screen, such as screen capture, etc; or
                            </li>
                            <li>
                                any other acts which the Company deems inappropriate.
                            </li>
                        </ol>
                    </li>
                    <li>
                        If the Company considers that any acts of Users fall under any of the items stated in (a) to (p) above, the Company may take any or all of the following measures, without notifying such Users in advance:
                        <ol data-hierarchy="second">
                            <li>
                                limit usage of the Services;
                            </li>
                            <li>
                                terminate the Agreements and remove such Users;
                            </li>
                            <li>
                                delete the content and change in the scope of publication on the Service posted by the users; and
                            </li>
                            <li>
                                take any other measures which the Company reasonably deems necessary.
                            </li>
                        </ol>
                    </li>
                </ol>
            </section>
            <section>
                <h4>
                    Termination for Cause
                </h4>
                <ol>
                    <li>
                        The Company may unilaterally terminate the Agreements with Users, and unsubscribe them, if such Users fall under any of the categories in the following items:
                        <ol data-hierarchy="second">
                            <li>
                                if information registered by the Users contains false information;
                            </li>
                            <li>
                                if a User do not hold a medical license;
                            </li>
                            <li>
                                if a User or Users have been removed by the Company before;
                            </li>
                            <li>
                                if a person including a User's heirs inform the Company of such User's death or if the Company confirms such User's death;
                            </li>
                            <li>
                                if a minor uses the Services without the consent of the minor's legal representative;
                            </li>
                            <li>
                                if an adult under guardianship, a person under curatorship, or a person under other similar assistance uses the Services without the consent of his or her adult guardian, curator or assistant;
                            </li>
                            <li>
                                if Users do not respond to the Company's request promptly; or
                            </li>
                            <li>
                                if the Company deems it necessary to terminate the Agreements with Users.
                            </li>
                        </ol>
                    </li>
                    <li>
                        With respect to the immediately preceding paragraph, the Company may unilaterally terminate the Agreements with such Users by giving notifications to such Users no later than thirty (30) days before such termination. A User may unilaterally terminate the Agreement by following the termination procedures stipulated by the Company on the month of the effective termination date.
                    </li>
                    <li>
                        If any Agreement with a User is terminated in accordance with paragraph 1 or 2 above, all the obligations of the User or Users will be removed from the Services as a result of such termination will be accelerated and become immediately due and payable, and such Users must forthwith fulfill all of its obligations to the Company.
                    </li>
                </ol>
            </section>
            <section>
                <h4>
                    No Guarantee and Disclaimer
                </h4>
                <ol>
                    <li>
                        The Company does not make any guarantee that contents of the Services are complete, accurate, or valid and the Company does not guarantee that the Services will not be interrupted, stopped, or undergo any other failure.
                    </li>
                    <li>
                        During use of Services by Users, transition may sometimes occur from the Services to other relevant services operated by a third party ("External Services"). In this case, Users must agree to the terms and conditions, including the terms of use, of such External Services, and use of the Services and such External Services by the Users at their sole responsibility. The Company does not make any guarantee that the contents of External Services are complete, accurate or valid.
                    </li>
                    <li>
                        The Company is not obliged to compensate any Users for any damage such Users may incur due to their failure to change the information registered in the Services.
                    </li>
                    <li>
                        Users must use the Services within the scope permitted by all applicable laws and regulations. The Company will not be responsible for any breach of laws or regulations of any country, including Japan, by Users.
                    </li>
                    <li>
                        The Company will not be responsible for any damage caused by loss of User Information due to unforeseen acts, including unlawful access by any third party.
                    </li>
                    <li>
                        The Company will not be responsible for any non-performance of a part or all of obligations under the Agreements due to force majeure events beyond the Company's control, including an act of God, fire, labor strike, trade suspension, war, civil war, and outbreak of an infectious disease.
                    </li>
                    <li>
                        The Company will not be responsible for any problem that occurs between the Users (which is related or not related to the Services) in connection with usage of the Services. Such Users must resolve such problem at their sole cost and expense.
                    </li>
                </ol>
            </section>
            <section>
                <h4>
                    Damages
                </h4>
                <ol>
                    <li>
                        Users must compensate the Company for any damages arising from any breach of these Terms of Use or use of the Services (including lost profit and attorneys' fees).
                    </li>
                    <li>
                        Notwithstanding other provisions of this Terms of Use and subject to next following paragraph, if the Company causes damages to Users for a reason attributable to the Company, the Company's compensation for such damages will be limited to amounts specified in the following items:
                        <ol data-hierarchy="second">
                            <li>
                                if the damages are caused by the Company's willful misconduct or gross negligence: the total amount of such damages; or
                            </li>
                            <li>
                                if the damages are caused by the Company's negligence other than gross negligence: ordinary damages which are caused actually and directly by such negligence (excluding special damages, lost profit, indirect damages and attorneys' fees).
                            </li>
                        </ol>
                    </li>
                    <li>
                        Notwithstanding the immediately preceding paragraph, if a User is a corporation or uses the Services for its business purpose, the Company shall not be responsible for any damage incurred by such User in connection with the Services, except for gross negligence or willful misconduct by the Company. Compensation for damages under this paragraph shall not exceed the total fees for the Services for one (1) year, prior to the day when such damages occur.
                    </li>
                </ol>
            </section>
            <section>
                <h4>
                    Discontinuation of the Services
                </h4>
                <ol>
                    <li>
                        The Company may change or discontinue all or part of the Services at the Company's discretion.
                    </li>
                    <li>
                        In the case of immediately preceding paragraph, the Company will not be responsible for any ensuing damage unless the Company causes such damage by its willful misconduct or gross negligence.
                    </li>
                </ol>
            </section>
            <section>
                <h4>
                    Confidentiality
                </h4>
                <ol>
                    <li>
                        Users and the Company must strictly and appropriately manage any confidential information (including know-how of the Services, information of the Company's systems, and any technical or business confidential information) of the other party, and must not disclose, provide or divulge such confidential information to any third party (including the Company's affiliates and contractors) without the prior written consent of the other party.
                    </li>
                    <li>
                        The information in the following items shall not be considered Confidential Information:
                        <ol data-hierarchy="second">
                            <li>
                                any information that the receiving party already has in its possession at the time of disclosure;
                            </li>
                            <li>
                                any information that is publicly known at the time of disclosure or becomes publicly known by no fault of the receiving party after such disclosure;
                            </li>
                            <li>
                                any information lawfully obtained from a third party after the disclosure by the disclosing party;
                            </li>
                            <li>
                                any information developed or created independently of disclosed Confidential Information; and
                            </li>
                            <li>
                                any information required to disclose by law or pursuant to a court order.
                            </li>
                        </ol>
                    </li>
                    <li>
                        Upon the other party's request or the termination of Agreements, Users and the Company must return confidential information to the other party, or destroy confidential information, without delay in accordance with the other party's instructions and must not use such confidential information thereafter.
                    </li>
                    <li>
                        If the Company discloses Users' confidential information to an affiliate or an out-source of the Company with the consent of such Users, the Company will not be responsible for the handling of such confidential information by such affiliate or out-source.
                    </li>
                    <li>
                        The Company may use Users' confidential information for the purpose of providing the Services.
                    </li>
                </ol>
            </section>
            <section>
                <h4>
                    Exclusion of Anti-Social Forces
                </h4>
                <ol>
                    <li>
                        Users and the Company respectively represent and warrant that they are not a gang, a gang member, an individual for whom 5 years have not passed since the individual left the gang, a quasi-member of a gang, a gang affiliate or group, a corporate racketeer, a blackmailer camouflaged as a social movement activist, a gang specializing in intelligence crimes, or any other groups or persons equivalent to any of the above (collectively as "Anti-Social Forces") and that Users do not fall under any of the following categories, and warrant that Users will not fall under any of the categories in the following items in the future:
                        <ol data-hierarchy="second">
                            <li>
                                Users have relationships where Anti-Social Forces are recognized to control the management;
                            </li>
                            <li>
                                Users have relationships where Anti-Social Forces are recognized to be substantially involved in the management;
                            </li>
                            <li>
                                Users have relationships in which such Users are recognized to be using illegal Anti-Social Forces; for example, for the purpose of acquiring wrongful gain for itself or a third party, or for the purpose of inflicting damage on a third party;
                            </li>
                            <li>
                                Users provide funds or benefits to Anti-Social Forces; or
                            </li>
                            <li>
                                Users' officers or persons substantially involved in its management have socially reprehensible relationships with Anti-Social Forces.
                            </li>
                        </ol>
                    </li>
                    <li>
                        Users and the Company respectively warrant that they will not engage in any of the following actions, either by themselves or through the use of a third party:
                        <ol data-hierarchy="second">
                            <li>
                                violent demands;
                            </li>
                            <li>
                                unlawful and unjust demands;
                            </li>
                            <li>
                                threatening behavior or use of violence in connection with Agreements;
                            </li>
                            <li>
                                spreading rumors, damaging the reputation of the Company by using fraudulent means or force, or obstructing the service of the Company; and
                            </li>
                            <li>
                                any other actions equivalent to any of the foregoing.
                            </li>
                        </ol>
                    </li>
                    <li>
                        If Users or the Company fall under any of the categories in each item of paragraph 1 above, conduct any actions as set forth in each item of the immediately preceding paragraph, or make any false statement concerning their representations and warranties as set in paragraph 1 above, the non-breaching party may terminate the Agreements without any written notice, regardless of any ground attributable to the Company.
                    </li>
                    <li>
                        Users acknowledge and agree that if the Company terminates the Agreements in accordance with the immediately preceding paragraph, the Company will not be responsible to compensate Users for any damage caused by the termination of Agreements.
                    </li>
                </ol>
            </section>
            <section>
                <h4>
                    Enquiry
                </h4>
                <ol>
                    <li>
                        The Company will use its reasonable efforts to answer Users' enquiries concerning the Services; provided, however, the Company will not be obliged to make such answer, unless otherwise obliged by laws, regulations, or these Terms of Use.
                    </li>
                    <li>
                        The Company will not be obliged to explain the reason for not answering any specific enquiries from a User.
                    </li>
                </ol>
            </section>
            <section>
                <h4>
                    Assignment of Status
                </h4>
                <p>
                    Neither Users nor the Company may, without the prior written consent of the other party, transfer the contractual status under the Agreements or these Terms of Use to a third party, assign or transfer all or part of its rights and obligations under the Agreements or these Terms of Use to a third party, or encumber its rights under the Agreements or these Terms of Use as collateral; provided, however, that this does not apply in case of share transfer, business transfer, merger, company split, and other structural reorganization.
                </p>
            </section>
            <section>
                <h4>
                    Personal Information
                </h4>
                <p>
                    The Company will handle personal information in connection with the Services, pursuant to "Privacy Policy" stipulated by the Company.
                </p>
            </section>
            <section>
                <h4>
                    Severability
                </h4>
                <ol>
                    <li>
                        If a provision of these Terms of Use is held invalid under any applicable law, such invalidity will not affect any other provision of these Terms of Use that can be given effect without the invalid provision.
                    </li>
                    <li>
                        If a provision of these Terms of Use is held invalid under any applicable law in relation to a part of Users, such invalidity will not affect any provision of these Terms of Use in relation to the other Users. 
                    </li>
                </ol>
            </section>
            <section>
                <h4>
                    Measures against Breach
                </h4>
                <ol>
                    <li>
                        If Users find any act of breaching these Terms of Use, Users must inform the Company of such breach.
                    </li>
                    <li>
                        Users may not file any objection to the Company's measures against any act of breaching these Terms of Use.
                    </li>
                </ol>
            </section>
            <section>
                <h4>
                    Term of this Agreement
                </h4>
                <p>
                    The Agreement is valid from the execution date of such Agreement until such Agreement is terminated or expired; provided, however that the provisions of Article 8 (Intellectual Property Rights), paragraph 3 of Article 10 (Termination for Cause), Articles 11 (No Guarantee and Disclaimer) to 13 (Discontinuation of the Services), paragraphs 3 and 4 of Article 15 (Exclusion of Anti-Social Forces), Article 17 (Assignment of Status), Article 19 (Severability), this  Article 21 (Term of this Agreement), Article 23 (Governing Law) and Article 24 (Jurisdiction) will survive the termination of the Agreement and will remain in full force and effect after the termination of the Agreement.
                </p>
            </section>
            <section>
                <h4>
                    Amendment
                </h4>
                <ol>
                    <li>
                        If the Company reasonably deems necessary, the Company may amend these Terms of Use in accordance with Article 548-4 of the Civil Code of Japan.
                    </li>
                    <li>
                        If the Company intends to amend these Terms of Use, The Company will notify or announce the fact of such change, its effective date, and the details of the change to the members in accordance with the provisions of the Terms of Use.
                    </li>
                    <li>
                        Notwithstanding preceding two paragraphs, Users will be deemed to have agreed to such amendment if Users do not cease the use of Services or do not terminate the Agreements upon receiving such notification from the Company.
                    </li>
                </ol>
            </section>
            <section>
                <h4>
                    Governing Law
                </h4>
                <p>
                    These Terms of Use shall be governed by and construed in accordance with the laws of Japan.
                </p>
            </section>
            <section>
                <h4>
                    Jurisdiction
                </h4>
                <p>
                    Any dispute between Users and the Company will be adjudicated in the Tokyo District Court.
                </p>
            </section>
            <section>
                <h4>
                    Miscellaneous
                </h4>
                <ol>
                    <li>
                        Users must follow any rules separately stipulated by the Company regarding any matter not covered in these Terms of Use. In this case, such rules will constitute as an inseparable part of these Terms of Use.
                    </li>
                    <li>
                        Rules as stipulated in the immediately preceding paragraph will be effective the moment such rules are published or announced on the place designated by the Company.
                    </li>
                    <li>
                        If there is any conflict between such rules as stipulated in paragraph 1 above and these Terms of Use, these Terms of Use will prevail.
                    </li>
                </ol>
            </section>
            <p>
                Supplementary provisions<br />
                Established and effective as of June 7, 2023 
            </p>
        </StyledTerms>
    );
};
